module.exports = __webpack_public_path__ + "img/emoji_62.ff6c446d.png";